module.exports = __webpack_public_path__ + "static/media/ticket-export-1.2047be38.jpg";